const PRESERVED_STYLE_PROPERTIES = [
	"maxHeight",
	"minHeight",
	"height",
	"width",
	"left",
	"display",
	"visibility",
	"position",
	"transitionProperty",
];

/**
 * Determines the height (including margin independent of box-sizing)
 * of the node even if it is not visible
 *
 * @param {HTMLElement} node
 * @return {integer}
 */
export async function getExpectedHeight(node) {
	// Save properties which will be temporary overwritten
	const styleBackup = {};
	PRESERVED_STYLE_PROPERTIES.forEach(property => {
		styleBackup[property] = node.style[property];
	});

	// We want to position the content box absolutely outside the viewport to determine
	// its height. To not lose the width of the box we need to determine it first.
	Object.assign(node.style, {
		transitionProperty: "none",
		height: "0px",
		display: "",
	});

	await Promise.resolve();

	const width = node.offsetWidth;

	// Displaying the content box somewhere enables us to determine its height.
	// To not render anything ugly in the users viewport, we position it absolutely
	// somewhere outside.
	Object.assign(node.style, {
		visibility: "hidden",
		position: "absolute",
		left: "-1000vw",
		width: width + "px",
		maxHeight: "initial",
		minHeight: "initial",
		height: "auto",
	});
	const height = node.offsetHeight;

	// Restore overwritten properties
	Object.assign(node.style, styleBackup);

	return height;
}
